import styles from "../../styles/PLMApp.module.css";
// src/components/plm/CategoryRow.jsx

import { useState } from "react";

import { stepDocId } from "../../utils/utils";
import StepNode from "./StepNode";

export default function CategoryRow({
  category,
  catIndex,
  steps,
  onOpenStep,
  onStatusChange,
  supplierId,
  statusDisabled,
  isAdmin,
}) {
  const [open, setOpen] = useState(true);

  const stepKeys = category.steps.map((_, i) =>
    stepDocId(supplierId, category.id, i),
  );
  const total = stepKeys.length;
  const done = stepKeys.filter((k) => steps[k]?.status === "done").length;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div className={styles.categoryRow}>
      <div className={styles.categoryHeader} onClick={() => setOpen((p) => !p)}>
        <div className={styles.categoryHeaderLeft}>
          <span className={styles.categoryNum}>
            {String(catIndex + 1).padStart(2, "0")}
          </span>
          <span className={styles.categoryName}>{category.name}</span>
        </div>
        <div className={styles.categoryProgress}>
          <span style={{ fontSize: 9 }}>
            {done}/{total}
          </span>
          <div className={styles.categoryProgressBar}>
            <div
              className={styles.categoryProgressFill}
              style={{ width: `${pct}%` }}
            />
          </div>
          <span style={{ fontSize: 9 }}>{pct}%</span>
        </div>
        <span
          className={`${styles.categoryChevron} ${open ? styles.categoryChevronOpen : ""}`}
        >
          ▶
        </span>
      </div>

      {open && (
        <div className={styles.stepsScrollArea}>
          <div className={styles.stepsRow}>
            {category.steps.map((title, i) => {
              const docId = stepDocId(supplierId, category.id, i);
              const stepData = steps[docId] || {
                status: "not_started",
                stepTitle: title,
                stepNumber: i + 1,
              };

              return (
                <div
                  key={docId}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <StepNode
                    step={stepData}
                    docId={docId}
                    index={i}
                    category={category}
                    onOpen={onOpenStep}
                    onStatusChange={onStatusChange}
                    statusDisabled={statusDisabled}
                    isAdmin={isAdmin}
                  />
                  {i < category.steps.length - 1 && (
                    <div className={styles.stepConnector} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
